// extracted by mini-css-extract-plugin
module.exports = {"data_container":"style_data_container__IXgDj","image_container":"style_image_container__23BG-","video_container":"style_video_container__1Sf68","youtube":"style_youtube__1WFNB"};